import { sendGTMEvent } from '@b-stock/fe-core/bstock-next/components'

import { GTM_PLATFORM } from './constants'

export function trackSignUpStart(ctaLocation?: string) {
  sendGTMEvent({
    event: 'sign_up_start',
    platform: GTM_PLATFORM,
    method: 'fusionauth',
    cta_location: ctaLocation,
  })
}
